<template>
    <div class="loader"></div>
</template>

<script>
export default {
    name: 'TheSpinner'
}
</script>

<style lang="css" scoped>

.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #9A2B0B;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  margin-right: 5px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
